import React from 'react'
import Icon from 'srcReact/components/icons/Icon'
import Variant from 'srcReact/Dashboard/components/common/Variant'
import styles from './styles.module.scss'

function EngagementItem({ name, icon, number, variant }) {
  return (
    <div className={styles.listItem}>
      <div className={styles.detail}>
        <div className={styles.icon}>
          <Icon name={icon} size='large24' />
        </div>
        <div className={styles.nameCount}>
          <span className={styles.name}>{name}</span>
          <span className={styles.count}>{number}</span>
        </div>
      </div>
      <Variant variation={variant} />
    </div>
  )
}

export default EngagementItem
